import { dayLabel } from "./utils";

export default function ApprovalsHistory({ history }) {
  if (history.length === 0) {
    return (
      <div className="px-5 py-10 text-center text-xs font-mono text-zinc-400" data-testid="team-approvals-history-empty">
        NO DECISIONS YET
      </div>
    );
  }
  return (
    <table className="w-full text-sm" data-testid="team-approvals-history">
      <thead className="bg-zinc-50 border-b border-zinc-950">
        <tr className="text-xs tracking-wider uppercase">
          <th className="text-left px-4 py-2.5">Employee</th>
          <th className="text-left px-4 py-2.5">Dept</th>
          <th className="text-left px-4 py-2.5">Type</th>
          <th className="text-left px-4 py-2.5">Dates</th>
          <th className="text-left px-4 py-2.5">Days</th>
          <th className="text-left px-4 py-2.5">Cover</th>
          <th className="text-left px-4 py-2.5">Decision</th>
          <th className="text-left px-4 py-2.5">Decided on</th>
          <th className="text-left px-4 py-2.5">By</th>
          <th className="text-left px-4 py-2.5">Note</th>
        </tr>
      </thead>
      <tbody data-testid="team-approvals-history-tbody">
        {history.map((l) => (
          <tr key={l.id} className="border-b border-zinc-100 align-top">
            <td className="px-4 py-3 font-medium">
              {l.employee_name || l.employee_id}
              {l.employee_no && <div className="text-[10px] font-mono text-zinc-400">{l.employee_no}</div>}
            </td>
            <td className="px-4 py-3 text-zinc-600">{l.employee_department || l.department || "—"}</td>
            <td className="px-4 py-3 capitalize text-zinc-600">
              {l.type}
              {l.half_day && <span className="ml-1 text-[9px] font-mono uppercase text-[#FF3E00]">· {l.half_day}</span>}
            </td>
            <td className="px-4 py-3 tnum text-xs">
              <div>{l.start_date}</div>
              <div className="text-zinc-400">→ {l.end_date}</div>
            </td>
            <td className="px-4 py-3 tnum">{dayLabel(l)}</td>
            <td className="px-4 py-3 text-xs text-zinc-600">{l.cover_employee_name || <span className="text-zinc-400">—</span>}</td>
            <td className="px-4 py-3">
              <span className={`text-[10px] font-mono px-1.5 py-0.5 ${l.status === "approved" ? "bg-emerald-50 text-emerald-700 border border-emerald-300" : "bg-red-50 text-[#D0021B] border border-[#D0021B]"}`}>
                {l.status?.toUpperCase()}
              </span>
            </td>
            <td className="px-4 py-3 text-xs text-zinc-500 tnum">{l.decided_at ? new Date(l.decided_at).toLocaleDateString() : "—"}</td>
            <td className="px-4 py-3 text-xs text-zinc-500">
              {l.decided_by || "—"}
              {l.decided_by_role && <div className="text-[9px] font-mono text-zinc-400 uppercase">{l.decided_by_role}</div>}
            </td>
            <td className="px-4 py-3 text-xs text-zinc-600 max-w-xs">{l.decision_note || <span className="text-zinc-400">—</span>}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
